import { Button } from "@components/ui/Button"
import { Tooltip } from "@components/ui/Tooltip"
import { trackEvent } from "@features/tracking/tracking"
import { FilmWishlistBasicsFragment } from "@generated-types"
import { tv } from "@utils/tw"
import { IconWishlistAnimated } from "./IconWishlistAnimated"
import { useWishlistEnabled, useWishlistToggle } from "./useWishlist"

type Props = {
  className?: string
  film: string | number | FilmWishlistBasicsFragment
}

export function WishlistButton(props: Props) {
  const enabled = useWishlistEnabled()
  const state = useWishlistToggle(props.film)
  const styles = createStyles({ className: props.className })

  if (!enabled || !state) return null

  return (
    <Tooltip
      label={state.active ? <div>Click to remove this item from your wishlist</div> : <div>Add to your watchlist</div>}
    >
      <Button
        variant="ghost"
        className={styles}
        onClick={(e) => {
          e.preventDefault()
          state.toggle()
          trackEvent("Add to Wishlist", {}, e.currentTarget)
        }}
        leftIcon={<IconWishlistAnimated active={state.active} />}
      >
        Watchlist
      </Button>
    </Tooltip>
  )
}

const createStyles = tv({
  base: ["bg-transparent gap-1"],
})
